import MainMenu from "./components/MainMenu.jsx";
import LearningFeed from "./components/LearningFeed.jsx";
import ChallengesScreen from "./components/ChallengesScreen.jsx";
import FlyoutScreen from "./components/FlyoutScreen.jsx";
import { BrowserRouter, Routes, Route, Navigate, useSearchParams, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setSessionToken } from './redux/userSlice';
import { authenticate } from './assets/virtual-flyout/auth-service.js';

export default function App() {
  const [ activeScreen, setActiveScreen ] = useState("Virtual Flyout");

  function changeScreen( screen ) {
    setActiveScreen(screen);
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginHandler />} />
        <Route path="/" element={
          <div className="app-container">
            <MainMenu activeScreen={activeScreen} onChange={changeScreen}/>
            {activeScreen === "Learning Feed" && <LearningFeed/> }
            {activeScreen === "Challenges" && <ChallengesScreen/> }
            {activeScreen === "Virtual Flyout" && <FlyoutScreen/> }
          </div>
        } />
      </Routes>
    </BrowserRouter>
  )
}

function LoginHandler() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('sessionToken');
    if (token) {
      authenticate(token).then(response => {
        if (response.ok) {
          setError(null);
          dispatch(setSessionToken(token));
          navigate('/');
        } else {
          response.json().then(data => {
            setError(`Authentication failed: ${data.error}`);
          });
        }
      }).catch(err => {
        setError(err.message);
      });
    }
  }, [searchParams, dispatch, navigate]);
  return <div>{error}</div>;
}